module.exports = __webpack_public_path__ + "assets/d3f640b2a4326e4a5cf4cddec263b927.json";